import { govosBaseUrl } from '../api/govos-api';

const createOdtemplateUrlOnLocalhost = (
  processId: number | string,
  startappId: number | string
) =>
  `http://localhost/bcl?verfahrenId=${processId}&startAPI=http%3A%2F%2Flocalhost%2Fgovos%2Fportal%2Fa3start%2F${startappId}%2Fapi1#/intro`;
export const createOnlinedienstTemplateUrl = (
  processId: string | number,
  startappId: string | number
) =>
  window.location.hostname === 'localhost'
    ? createOdtemplateUrlOnLocalhost(processId, startappId)
    : `${govosBaseUrl}/go/a/${processId}?c=bc`;

export enum LocalStorageKeys {
  Payment = 'default.payment',
  Auth = 'default.auth',
  Zustellweg = 'default.zustellweg',
  // Export Mode
  shouldRedirectInstantlyToExpertMode = 'shouldRedirectInstantlyToExpertMode'
}

export enum PathParams {
  isOdmOrigin = 'isOdmOrigin',
  redirectTo = 'redirectTo'
}
